import { memo } from "react";
import { Grid } from "@mui/material";

const EmptyChartNew = () => {
    
    return <Grid container className="box-center" >
        <Grid className='text-center'>
            <h2 className='content-heading'>You need to add or remove fields</h2>
            <p className='content-text'>Add Some Measures/Dimensions first</p>
        </Grid>
    </Grid>
}

export default memo(EmptyChartNew)